"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
var tslib_1 = require("tslib");
var Filter_1 = require("./Filter");
var Condition_1 = require("./Condition");
var Operator_1 = require("./Operator");
var Query_1 = require("./Query");
var Node_1 = require("./Node");
var Builder = /** @class */ (function (_super) {
    tslib_1.__extends(Builder, _super);
    function Builder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Joins the conditions by an logical AND
     * @param args The query nodes to join
     * @return Returns a new query which joins the given queries by a logical AND
     */
    Builder.prototype.and = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.addOperator('$and', (0, Query_1.flatArgs)(args));
    };
    /**
     * Joins the conditions by an logical OR
     * @param args The query nodes to join
     * @return Returns a new query which joins the given queries by a logical OR
     */
    Builder.prototype.or = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.addOperator('$or', (0, Query_1.flatArgs)(args));
    };
    /**
     * Joins the conditions by an logical NOR
     * @param args The query nodes to join
     * @return Returns a new query which joins the given queries by a logical NOR
     */
    Builder.prototype.nor = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.addOperator('$nor', (0, Query_1.flatArgs)(args));
    };
    /**
     * @inheritDoc
     */
    Builder.prototype.resultList = function (options, doneCallback, failCallback) {
        return this.where({}).resultList(options, doneCallback, failCallback);
    };
    /**
     * @inheritDoc
     */
    Builder.prototype.singleResult = function (options, doneCallback, failCallback) {
        return this.where({}).singleResult(options, doneCallback, failCallback);
    };
    /**
     * @inheritDoc
     */
    Builder.prototype.count = function (doneCallback, failCallback) {
        return this.where({}).count(doneCallback, failCallback);
    };
    Builder.prototype.addOperator = function (operator, args) {
        if (args.length < 2) {
            throw new Error("Only two or more queries can be joined with an ".concat(operator, " operator."));
        }
        args.forEach(function (arg, index) {
            if (!(arg instanceof Node_1.Node)) {
                throw new Error("Argument at index ".concat(index, " is not a query."));
            }
        });
        return new Operator_1.Operator(this.entityManager, this.resultClass, operator, args);
    };
    Builder.prototype.addOrder = function (fieldOrSort, order) {
        return new Filter_1.Filter(this.entityManager, this.resultClass).addOrder(fieldOrSort, order);
    };
    Builder.prototype.addFilter = function (field, filter, value) {
        return new Filter_1.Filter(this.entityManager, this.resultClass).addFilter(field, filter, value);
    };
    Builder.prototype.addOffset = function (offset) {
        return new Filter_1.Filter(this.entityManager, this.resultClass).addOffset(offset);
    };
    Builder.prototype.addLimit = function (limit) {
        return new Filter_1.Filter(this.entityManager, this.resultClass).addLimit(limit);
    };
    return Builder;
}(Query_1.Query));
exports.Builder = Builder;
Object.assign(Builder.prototype, Condition_1.Condition);
//# sourceMappingURL=data:application/json;base64,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